<template>
  <div>
    <div class="client-row">
      <label class="col-3"></label>
      <div class="col-9 pl-0">
        <span class="chart-criteria-label" style="font-size: 14px;">Recommendation Instructions</span>
      </div>
    </div>
    <div class="client-row">
      <label for="recommendation_role" class="col-3">Role</label>
      <div class="col-9 d-flex pl-0">
        <div class="col-3 m-0 p-0 d-flex">
          <input
            id="recommendation_role"
            name="recommendation_role"
            v-model="localRole"
            type="text"
            class="form-control w-100"
            :disabled="disabled"
            @change="saveRecommendationInstructions('N')"
          />
        </div>
        <div class="col-6 ml-1">
          <button type="button" class="btn btn-primary" :disabled="disabled || this.inputClientCode == ''" @click="saveRecommendationInstructions('Y')">
            Apply to Client Hierarchy
          </button>
        </div>
      </div>
    </div>
    <div class="client-row">
      <label for="recommendation_industry" class="col-3">Industry</label>
      <div class="col-9 d-flex pl-0">
        <div class="col-3 m-0 p-0 d-flex">
          <input
            id="recommendation_industry"
            name="recommendation_industry"
            v-model="localIndustry"
            type="text"
            class="form-control w-100"
            :disabled="disabled"
            @change="saveRecommendationInstructions('N')"
          />
        </div>
      </div>
    </div>
    <div class="client-row">
      <label for="recommendation_respondent_group" class="col-3">Respondent Group</label>
      <div class="col-9 d-flex pl-0">
        <div class="col-3 m-0 p-0 d-flex">
          <input
            id="recommendation_respondent_group"
            name="recommendation_respondent_group"
            v-model="localRespondentGroup"
            type="text"
            class="form-control w-100"
            :disabled="disabled"
            @change="saveRecommendationInstructions('N')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AIService from "../services/ai.service";
import AdminService from "../services/admin.service";

export default {
  name: "RecommendationInstructions",
  data() {
    return {
      defaultLocalRole: "Management Consultant",
      defaultLocalIndustry: "B2B",
      defaultLocalRespondentGroup: "Customers",
      localRole: "",
      localIndustry: "",
      localRespondentGroup: "",
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    role: {
      type: String,
      default: ""
    },
    industry: {
      type: String,
      default: ""
    },
    respondentGroup: {
      type: String,
      default: ""
    },
    inputClientCode: {
      type: String,
      default: ""
    },
  },
  mounted() {
    this.resetValues();
  },
  methods: {
    saveRecommendationInstructions(applyToHierarchy = "N") {
      this.$root.processServerRequest("Saving Recommendation Instructions");
      this.resetValues();
      AIService.saveRecommendationInstructions(
        this.inputClientCode,
        this.localRole,
        this.localIndustry,
        this.localRespondentGroup,
        applyToHierarchy,
        this.saveRecommendationInstructionsCallback,
        this
      );
    },
    saveRecommendationInstructionsCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        AdminService.displaySuccessMessage({ text: response.data.message });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    resetValues() {
      if (this.localRole.trim() === '') {
        this.localRole = this.defaultLocalRole; // default
      }
      if (this.localIndustry.trim() === '') {
        this.localIndustry = this.defaultLocalIndustry; // default
      }
      if (this.localRespondentGroup.trim() === '') {
        this.localRespondentGroup = this.defaultLocalRespondentGroup; // default
      }
    }
  },
  watch: {
    role: {
      immediate: true,
      handler(val) {
        this.localRole = val || "";
      }
    },
    industry: {
      immediate: true,
      handler(val) {
        this.localIndustry = val || "";
      }
    },
    respondentGroup: {
      immediate: true,
      handler(val) {
        this.localRespondentGroup = val || "";
      }
    },
    localRole(val) {
      this.$emit("update:role", val);
    },
    localIndustry(val) {
      this.$emit("update:industry", val);
    },
    localRespondentGroup(val) {
      this.$emit("update:respondentGroup", val);
    }
  }
};
</script>
